import React from "react";

// Components imports
import Button from "../../../common/Button";

// Scss imports
import css from "./DataVerification.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

interface DataVerificationProps {
  handleSubmit: Function;
  accountType: string;
  firstName: string;
  lastName: string;
  nationalId: string;
}

const DataVerification: React.FC<DataVerificationProps> = ({
  handleSubmit
}) => {
  const addBasicDataError = useSelector(
    (state: any) => state.updateMe.updateMeError
  );
  return (
    <div className={css.container}>
      {/*<div>
        <p>Тип налога: {accountType}</p>
        <p>Име: {firstName}</p>
        <p>Презиме: {lastName}</p>
        <p>ЈМБГ: {nationalId}</p>
			</div>*/}
      <p>{addBasicDataError}</p>
      <Button text="Submit" onButtonClickHandler={handleSubmit} />
    </div>
  );
};

export default DataVerification;
